module.exports = __webpack_public_path__ + "img/bank1.701d47ee.png";